export enum APIError {
  RecordNotFound = 'record_not_found',
}
